import React from 'react';
import axios from '../axios';
// eslint-disable-next-line import/order
import useAxios, { configure } from 'axios-hooks';

configure({ axios });

export default function useGetWiresFeaturedByFund(fundId) {
  const common = id => ({ url: `/api/v1/wires/featured_by/fund/${id}` });
  const [state, q] = useAxios({ ...common(fundId), method: 'GET' }, { manual: true });
  const executeQuery = React.useCallback(id => q(common(id)), [q]);
  return [state, executeQuery];
}
